import cn from 'classnames';
import Badge from 'components/badge';
import Radio from 'components/radio';
import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Gtm, gtm } from 'tracking/gtm';
import { OrderType } from '../../../../../../constants/order';

interface PropTypes {
  value: OrderType;
  onChange: (value: OrderType) => void;
  /** Discount percentage for subscription */
  subscriptionDiscount: number;
}

const OrderTypeForm: FC<PropTypes> = ({
  subscriptionDiscount,
  value,
  onChange,
}) => {
  const isOneOffSelected = value === OrderType.ONE_OFF;
  const onSetOneOff = useCallback(() => {
    onChange(OrderType.ONE_OFF);
    gtm({
      group: Gtm.GroupName.Subscription,
      name: Gtm.SubscriptionEventName.OrderTypeSelect,
      data: {
        label: OrderType.ONE_OFF,
      },
    });
  }, [onChange]);
  const onSetSubscription = useCallback(() => {
    onChange(OrderType.SUBSCRIPTION);
    gtm({
      group: Gtm.GroupName.Subscription,
      name: Gtm.SubscriptionEventName.OrderTypeSelect,
      data: {
        label: OrderType.SUBSCRIPTION,
      },
    });
  }, [onChange]);

  return (
    <ul>
      <li
        className={cn(
          'mb-2.5 flex cursor-pointer items-center',
          isOneOffSelected
            ? 'font-medium'
            : 'text-text-secondary hover:text-grey-700'
        )}
      >
        <Radio
          name={'OrderTypeForm'}
          onChange={onSetOneOff}
          checked={isOneOffSelected}
          value={OrderType.ONE_OFF}
          id={'one-off-radio'}
        >
          <span className="ml-2">
            <FormattedMessage id={'pdp:buy-panel:order-type:one-off'} />
          </span>
        </Radio>
      </li>

      <li
        className={cn(
          'flex cursor-pointer items-center',
          value === OrderType.SUBSCRIPTION
            ? 'font-medium'
            : 'text-text-secondary hover:text-grey-700'
        )}
      >
        <Radio
          name={'OrderTypeForm'}
          onChange={onSetSubscription}
          checked={value === OrderType.SUBSCRIPTION}
          value={OrderType.SUBSCRIPTION}
          id={OrderType.SUBSCRIPTION}
        >
          <span className="ml-2 flex items-center gap-2">
            <FormattedMessage id={'pdp:buy-panel:order-type:subscription'} />
            <Badge
              rounded
              type="Discount"
              className="px-2! py-1! text-xs leading-4"
            >
              <FormattedMessage
                id="pdp:buy-panel:order-type:subscription:cut-out"
                values={{
                  value: `-${Number(subscriptionDiscount)}%`,
                }}
              />
            </Badge>
          </span>
        </Radio>
      </li>
    </ul>
  );
};

export default OrderTypeForm;
